import React, { useState, useEffect } from 'react'

import {
    Button,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
} from "@material-ui/core";
import { DatePicker } from '@material-ui/pickers';

import Autocomplete from '@material-ui/lab/Autocomplete';

import {Loading} from '../../../components/Loading/Loading'

import { gql, useApolloClient } from '@apollo/client';
import { useDispatch } from 'react-redux';

import { AddBPMApplicationMessages } from '../../../redux/reducers/BPMReducer';
import BPMDialog from '../../../components/BPMTable/TableComponents/Dialogs/BPMDialog';
import { getNextDayPlainDateString, getTodayDateString, parsePlainDate, toPlainDateString } from '../../../utils/DateUtils';

const ACTIVATE = gql`
    mutation(
        $id: String!,
        $changeReason: String!,
        $expirationDate: Date,
    ){
        bayphoneActivate(
            id: $id,
            changeReason: $changeReason,
            expirationDate: $expirationDate,
        ) {
            bayphone {
                id
            }
        }
    }
`;

const CHANGE_REASONS = gql`
    query {
        allBayphoneChangeReasons {
            id
            name
        }
    }
`;

const BayphoneActivateDialog = props => {
    const [ isLoading, setLoading ] = useState(false);

    const { open, handleClose, selectedRows, t } = props;

    const [ changeReason, setChangeReason ] = useState(null);
    const [ expirationDate, setExpirationDate ] = useState('');

    // Prefill expirationDate from selectedRows[0].expirationDate when dialog opens
    useEffect(() => {
        if (open && selectedRows.length > 0) {
            setExpirationDate(selectedRows[0].expirationDate?.split('T')[0] || '');
        } else {
            setExpirationDate('');
        }
    }, [open, selectedRows]);

    const dispatch = useDispatch()
    const client = useApolloClient()

    useEffect(() => {
        return () => {
            setLoading(false);
            setChangeReason(null);
            setExpirationDate('');
        };
    }, []);

    const onClickProcess = () => {
        setLoading(true)

        client.mutate({
            mutation: ACTIVATE,
            variables: {
                id: selectedRows[0].id,
                expirationDate: expirationDate,
                changeReason: changeReason.value,
            },
        })
        .then(result => {
            const success = result.data;

            if (success) {
                handleQueryExecuted(true, t("State change successfully executed"));
            } else {;
                handleQueryExecuted(false, t('An error occurred while changing the state of the Bayphone'));
            }
        })
        .catch(error => {
            handleQueryExecuted(false, JSON.stringify(error))
        })
        .finally(() => {
          setLoading(false);
        });
    };

    const createApplicationMessage = (text, variant) => {
        dispatch(AddBPMApplicationMessages({
            text: text,
            duration: 8000,
            variant: variant,
        }))
    }

    const handleQueryExecuted  = (success, message) => {
        createApplicationMessage(message, success ? 'success' : 'error');
        setLoading(false);
        onCloseDialog();
    }

    const onCloseDialog = () => {
        setExpirationDate('')
        setChangeReason(null)
        handleClose();
    }

    const submitable = () => {
        return (changeReason) && (isLoading === false)
    }

  const todayDateString = getTodayDateString();
  const todayDate = parsePlainDate(todayDateString);
  const minExpirationDateFormatted = getNextDayPlainDateString(todayDateString);

  const handleExpirationDateChange = date => {
    setExpirationDate(toPlainDateString(date) || '');
  };

    return (
        <Loading query={CHANGE_REASONS} showLoading={false}>
            {(data) => {
                return (
                    <BPMDialog
                    open={open}
                    onClose={onCloseDialog}
                    maxWidth='md'
                    aria-labelledby='alert-dialog-title'
                    aria-describedby='alert-dialog-description'
                    >
                        <DialogTitle id='alert-dialog-title'>
                            <span onClick={(event, reason) => onCloseDialog(event, reason)} style={{fontSize: '1.5em',  cursor: 'pointer', position: 'absolute', right: '5px', top: '-5px'}}>&times;</span>
                            {t('bayphone:Bayphone')}
                        </DialogTitle>
                        <DialogContent>
                            <Autocomplete
                                options={data.allBayphoneChangeReasons.map(item => ({label: item.name, value: item.id}))}
                                getOptionLabel={(option) => option.label || ''}
                                getOptionSelected={(option, value) => option.value === value.value}
                                onChange={(event, newValue) => { setChangeReason(newValue) }}
                                value={changeReason}
                                renderInput={(params) => (
                                    <TextField
                                    {...params}
                                    label={t('bayphone:Change reason')}
                                    variant='outlined'
                                    style={{ marginBottom: 15 }}
                                    />
                                )}
                            />
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <DatePicker
                                label={t('bayphone:Valid since')}
                  value={todayDate}
                  disabled
                  inputVariant='outlined'
                  format='P'
                  onChange={() => {}}
                  style={{ width: 250, marginBottom: 16 }}
                            />
                <DatePicker
                                label={t('bayphone:Expiration date')}
                  value={expirationDate ? parsePlainDate(expirationDate) : null}
                  onChange={handleExpirationDateChange}
                  minDate={minExpirationDateFormatted ? parsePlainDate(minExpirationDateFormatted) : todayDate}
                  inputVariant='outlined'
                  format='P'
                  style={{ width: 250 }}
                            />
              </div>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: 'space-between' }}>
                            <div>
                                <Button
                                    style={{ marginRight: 20 }}
                                    onClick={onCloseDialog}
                                    variant='contained'
                                    disabled={isLoading}
                                >
                                    {t(':Cancel')}
                                </Button>
                                <Button
                                    onClick={onClickProcess}
                                    variant='contained'
                                    color='primary'
                                    disabled={!submitable()}
                                >
                                    {t('tableFooter:Activate')}
                                </Button>
                            </div>
                        </DialogActions>
                    </BPMDialog>
                )
            }}
        </Loading>
    )
};

export default BayphoneActivateDialog;
